import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.assign.js";
import { __rest } from "tslib";
import cx from 'classnames';
import React from 'react';
import { BackOutlined, FailOutlined, ShareOutlined } from '@bcz/icons';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import { useConfig } from '../config-provider';
import Space from '../space';
import { NavBarActionButton } from './nav-bar-action-button';
var classPrefix = 'nib-nav-bar';
var backIconRecord = {
  back: /*#__PURE__*/React.createElement(BackOutlined, null),
  close: /*#__PURE__*/React.createElement(FailOutlined, null)
};
var defaultProps = {
  backIcon: 'back',
  backText: '',
  showShareButton: false,
  left: [],
  right: []
};
export var NavBar = function NavBar(p) {
  var _cx;

  var _a, _b;

  var _useConfig = useConfig(),
      debug = _useConfig.debug;

  var props = mergeProps(defaultProps, p);
  var backIcon = props.backIcon,
      backText = props.backText,
      showShareButton = props.showShareButton;
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: cx(classPrefix, (_cx = {}, _cx[classPrefix + "-debug"] = debug, _cx))
  }, /*#__PURE__*/React.createElement(Space, {
    direction: "horizontal",
    align: "center",
    justify: "start",
    className: classPrefix + "-left"
  }, Boolean(backIcon || backText) && /*#__PURE__*/React.createElement(NavBarActionButton, {
    key: "back",
    icon: (_a = backIconRecord[backIcon]) !== null && _a !== void 0 ? _a : backIcon,
    text: backText,
    clickable: true,
    onClick: props.onBack
  }), props.left.filter(function (x) {
    return x.visible !== false;
  }).map(function (_a) {
    var key = _a.key,
        props = __rest(_a, ["key"]);

    return /*#__PURE__*/React.createElement(NavBarActionButton, Object.assign({
      key: key
    }, props));
  })), /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-title"
  }, (_b = props.title) !== null && _b !== void 0 ? _b : props.children), /*#__PURE__*/React.createElement(Space, {
    direction: "horizontal",
    align: "center",
    justify: "end",
    className: classPrefix + "-right"
  }, props.right.filter(function (x) {
    return x.visible !== false;
  }).map(function (_a) {
    var key = _a.key,
        props = __rest(_a, ["key"]);

    return /*#__PURE__*/React.createElement(NavBarActionButton, Object.assign({
      key: key
    }, props));
  }), showShareButton && /*#__PURE__*/React.createElement(NavBarActionButton, {
    key: "share",
    icon: /*#__PURE__*/React.createElement(ShareOutlined, null),
    clickable: true,
    onClick: props.onShareClick
  }))));
};